import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthSplitLayout from '../../../components/auth/AuthSplitLayout';

export default function ResetPasswordPage() {
  const navigate = useNavigate();

  const onSubmit: React.FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    navigate('/login');
  };

  return (
    <AuthSplitLayout
      title="Reset password"
      subtitle="Choose a new password for your account"
    >
      <form onSubmit={onSubmit} className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-gray-700">New password</label>
          <input
            name="password"
            type="password"
            autoComplete="new-password"
            required
            className="mt-2 w-full rounded-lg border border-gray-300 px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-green-500"
            placeholder="••••••••"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Confirm new password</label>
          <input
            name="confirmPassword"
            type="password"
            autoComplete="new-password"
            required
            className="mt-2 w-full rounded-lg border border-gray-300 px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-green-500"
            placeholder="••••••••"
          />
        </div>

        <button
          type="submit"
          className="w-full rounded-lg bg-green-600 px-4 py-2.5 text-white font-semibold hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
        >
          Update password
        </button>

        <div className="text-sm text-gray-600">
          <Link to="/login" className="font-medium text-green-700 hover:text-green-800">
            Back to sign in
          </Link>
        </div>
      </form>
    </AuthSplitLayout>
  );
}
